<template>
  <div :class="['note', color(content.color)]">
    <Image v-if="content.icon" :source="content.icon" class="note__icon" />
    <div class="note__content">
      <p>{{ content.description }}</p>
      <LangRouterLink :to="{ name: content.route }" class="button" :title="content.label">
        {{ content.label }}
      </LangRouterLink>
    </div>
  </div>
</template>

<script>
import { Image, LangRouterLink } from '@/components/global'
import { color } from '@/helpers/color.js'

export default {
  name: 'NoteBlock',
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
  components: {
    Image,
    LangRouterLink,
  },
  methods: { color },
}
</script>
